import * as React from 'react';

function SvgContactUs(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="contact_us_svg__clip-path">
          <path
            id="contact_us_svg__Rectangle_305"
            d="M0 0h24v24H0z"
            data-name="Rectangle 305"
            transform="translate(116 758)"
            stroke="#fff"
            fill="#fff"
          />
        </clipPath>
        <style>{`.contact_us_svg__cls-5{fill:${props.fill}}`}</style>
      </defs>
      <g
        id="contact_us_svg__contact_us"
        transform="translate(-116 -758)"
        clipPath="url(#contact_us_svg__clip-path)"
      >
        <g id="contact_us_svg__Group_362" data-name="Group 362" transform="translate(116.5 758.5)">
          <path
            id="contact_us_svg__Path_687"
            d="M23.5 7.789c0-.03-.007-.06-.011-.09s0-.049-.009-.071 0-.016-.006-.024c-.007-.028-.018-.056-.027-.084s-.014-.05-.024-.073c0-.008-.008-.015-.012-.023-.011-.025-.027-.049-.04-.072s-.023-.047-.038-.069-.015-.018-.021-.027l-.013-.02c-.005-.006-.027-.027-.039-.042s-.03-.039-.048-.056-.019-.016-.029-.025-.044-.037-.067-.054-.036-.03-.056-.043l-.009-.007-3.957-2.519V.979A.98.98 0 0018.115 0H5.385a.98.98 0 00-.979.979V4.49L.453 7.007l-.009.007c-.02.013-.037.028-.055.042s-.046.035-.069.055-.02.017-.028.026l-.048.056-.04.042c-.013.015-.008.014-.013.02l-.022.027c-.007.009-.026.046-.038.069S.1 7.4.092 7.423c0 .008-.009.016-.012.023-.01.024-.016.054-.024.073s-.02.055-.027.084c0 .008-.005.016-.006.024 0 .023-.006.047-.009.071S0 7.758 0 7.788v14.776c0 .035.006.069.01.1s.01.06.017.09.018.062.028.092a.932.932 0 00.036.09.864.864 0 00.044.08.948.948 0 00.065.084c.009.012.015.025.024.036s.022.022.033.033a.973.973 0 00.072.072.705.705 0 00.15.112.862.862 0 00.084.045.934.934 0 00.088.036.918.918 0 00.283.057h21.587a1.012 1.012 0 00.2-.022c.017 0 .033-.011.049-.015a.987.987 0 00.143-.048c.022-.01.044-.024.065-.035a.945.945 0 00.11-.066c.022-.016.042-.034.063-.051a.987.987 0 00.093-.091c.009-.01.021-.018.03-.029s.015-.025.024-.036a.856.856 0 00.057-.087c.016-.027.03-.053.044-.08s.025-.059.036-.09a.9.9 0 00.028-.092.843.843 0 00.017-.09 1.019 1.019 0 00.01-.1V7.821c0-.004.01-.021.01-.032zM1.958 9.827l6.68 5.161-6.68 5.466zm8.864 5.905l.007-.005.464-.38a.721.721 0 01.913 0l.464.38.006.005 7.1 5.81H3.722zm4.039-.743l6.68-5.162v10.627zm5.958-7.078l-1.725 1.333V6.813zm-3.684-5.953v8.8l-3.844 2.969a2.674 2.674 0 00-3.084 0l-3.842-2.97v-8.8zM4.406 9.244L2.681 7.911l1.725-1.1z"
            data-name="Path 687"
            fill={props.fill}
          />
          <path
            id="contact_us_svg__Path_688"
            d="M104.479 28.928l-6.253 3.243-5.987-3.243V18.63h12.24z"
            data-name="Path 688"
            transform="translate(-86.594 -17.49)"
            fill={props.fill}
          />
          <path
            id="contact_us_svg__Path_689"
            d="M144.979 65.958h4.406a.979.979 0 100-1.958h-4.406a.979.979 0 100 1.958z"
            className="contact_us_svg__cls-5"
            data-name="Path 689"
            transform="translate(-135.188 -60.083)"
          />
          <path
            id="contact_us_svg__Path_690"
            d="M144.979 129.958h1.958a.979.979 0 000-1.958h-1.958a.979.979 0 100 1.958z"
            className="contact_us_svg__cls-5"
            data-name="Path 690"
            transform="translate(-135.188 -120.167)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgContactUs;
